<template>
	<div :class="['avatar-container', {'light-mode' : $route.meta.headerColor === 'light'}]" ref="avatarContainer">
		<div class="avatar" @click="isOpen = !isOpen">{{ getUserInitials() }}</div>
		<div class="user-dropdown" v-if="isOpen">
			<div class="name-container">
				<div class="initials">{{ getUserInitials() }}</div>
				<div class="names">
					<div class="name">{{ $store.getters.getUser.fullName }}</div>
					<div class="email">{{ $store.getters.getUser.email }}</div>
					<div v-if="$route.fullPath.includes('/gop')" class="country" @click="openCountrySelect">
						<div class="country-name">{{ $store.getters.getUser.gopUserCountry?.name || 'Country not selected' }}</div>
						<img class="mobile-icon" src="@/drc/assets/icons/edit-blue.svg" alt="Edit">
					</div>
				</div>
			</div>

			<div class="splitter"></div>
			<div class="logout-button" @click="handleLogout">
				{{ $t('sideMenu.logout') }}
			</div>
		</div>
		<gopChooseLanguage
			v-if="showChooseCountry"
			@closeDialog="hideChooseLanguagePopup"
			@submit="submitNewCountry"
		/>
	</div>
</template>

<script>
import {logout} from "@/common/services/login-service";
import GopChooseLanguage from "@/gop-redesign/pages/GopChooseLanguage.vue";
import {setGopCountry} from "@/common/services/common-request-service";
import {NOTIFICATION_TYPE} from "@/common/utils/constants";
import {EventButton} from "@/common/configurations/event-bus";

export default {
	name: "UserProfile",
	components: {GopChooseLanguage},
	data() {
		return {
			isOpen: false,
			showChooseCountry: false,
			checkInterval: null,
		}
	},
	watch: {
		$route(to, from) {
			if(!localStorage.getItem('isCountrySet') && to?.fullPath?.includes?.('/gop')) {
				this.checkInterval = setInterval(() => {
					if(this.$store.getters.getUser.id){
						this.tryForSelectCountry()
					}
				}, 1000)
			}
		}
	},
	mounted() {
		if(!localStorage.getItem('isCountrySet') && this.$route?.fullPath?.includes?.('/gop')) {
			this.checkInterval = setInterval(() => {
				if(this.$store.getters.getUser.id){
					this.tryForSelectCountry()
				}
			}, 1000)
		}
	},
	methods: {
		tryForSelectCountry(){
			const isTourSeen = localStorage.getItem('isHomePageTourSeen');
			if(isTourSeen){
				clearInterval(this.checkInterval);
				if(!this.$store.getters.getUser.gopUserCountry?.id){
					this.openCountrySelect();
				}
				localStorage.setItem('isCountrySet', 'true');
			}
		},
		openCountrySelect(){
			this.showChooseCountry = true;
			this.isOpen = false;
		},
		hideChooseLanguagePopup() {
			this.showChooseCountry = false;
			this.isOpen = false;
		},
		submitNewCountry(data){
			const countryId = data.country.value[0].id
			if(countryId){
				this.showChooseCountry = false;
				this.$loader.show({isWhite: true});
				setGopCountry(countryId).then(() => {
					this.showNotification(`${this.$t('notifications.successChangedCountry')}`, NOTIFICATION_TYPE.SUCCESS);
					this.$store.commit('setNewCountry', data.country.value[0]);
					EventButton.$emit('changedUserCountry', data.country.value[0])
				}).catch(() => {
					this.showNotification(`${this.$t('notifications.errorChangedCountry')}`, NOTIFICATION_TYPE.ERROR);
				}).finally(() => {
					this.$loader.hide();
				})
			}

		},
		getUserInitials() {
			if (!this.$store.getters.getUser || !this.$store.getters.getUser.fullName) {
				return ""
			}

			let splittedNamed = this.$store.getters.getUser.fullName.split(" ")
			let initials = "";
			if (splittedNamed.length === 1) {
				initials = splittedNamed[0].slice(0,1);
			} else if (splittedNamed.length === 2) {
				initials = splittedNamed[0].slice(0,1) + splittedNamed[1].slice(0,1);
			} else if (splittedNamed.length === 3) {
				initials = splittedNamed[0].slice(0,1) + splittedNamed[1].slice(0,1) + splittedNamed[2].slice(0,1);
			} else {
				initials = splittedNamed[0].slice(0,1);
			}

			return initials.toUpperCase();
		},
		handleLogout() {
			logout();
		},
		closeDropdown(event) {
			if (!this.$refs.avatarContainer.contains(event.target)) {
				this.isOpen = false;
			}
		}
	},
	created() {
		window.addEventListener('click', this.closeDropdown);
	},
	destroyed() {
		window.removeEventListener('click', this.closeDropdown);
	},
}
</script>

<style scoped lang="scss">
@import "@/common/assets/css/_variables.scss";

.avatar-container {
	position: relative;
	cursor: pointer;
	transition: top 0.4s ease-in;

	.avatar {
		width: 44px;
		height: 44px;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 4px;
		border: 1px solid #EBEBF52E;
		background: #001F33;
		color: #FFB81C;
		font-family: Tiempos Text, serif;
		font-weight: 400;
		font-size: 20px;
		line-height: 20px;
		letter-spacing: 0.36px;
		text-align: center;
	}

	.user-dropdown {
		top:50px;
		right: 0;
		position: absolute;
		height: fit-content;
		background: #001F33;
		border: 1px solid #FFFFFF2E;
		border-radius: 8px;
		display: flex;
		flex-direction: column;
		width: 333px;
		cursor: default;

		.splitter {
			width: 100%;
			height: 1px;
			background: #FFFFFF2E;
		}

		.name-container {
			display: flex;
			flex-direction: row;
			padding: 16px;
			gap: 16px;
			justify-content: flex-start;
			align-items: center;

			.initials{
				width: 44px;
				height: 44px;
				display: flex;
				justify-content: center;
				align-items: center;
				background: #FFB81C;
				color:black;
				clip-path: polygon(30% 0%, 100% 0%, 100% 100%, 0% 100%, 0% 30%);
				font-family: Tiempos Text, serif;
				font-weight: 400;
				font-size: 20px;
				line-height: 20px;
				letter-spacing: 0.36px;
				text-align: center;
			}

			.names {
				flex-direction: column;
				max-width: 238px;

				.name {
					font-family: Roboto, serif;
					font-weight: 600;
					font-size: 17px;
					line-height: 22px;
					letter-spacing: 0;
					color: #FCFCFE;
					margin-top: 2px;
					word-break: break-all;
				}

				.email {
					font-family: Roboto, serif;
					font-weight: 400;
					font-size: 12px;
					line-height: 16px;
					letter-spacing: 0;
					color: #FFB81C;
					margin-top: 2px;
					word-break: break-all;
				}

				.country{
					cursor: pointer;
					font-family: Roboto, serif;
					font-weight: 400;
					font-size: 12px;
					line-height: 16px;
					letter-spacing: 0;
					color: $gop-new-blue;
					margin-top: 2px;
					word-break: break-all;
					display: flex;
					img{
						height: 16px;
						color: $gop-new-blue;
						margin-left: 4px;
					}
				}
			}
		}

		.logout-button{
			padding: 16px;
			cursor: pointer;
		}
	}

	&.light-mode {
		.avatar {
			background: #ffffff;
			border: 1px solid #E5E5EA;
			color: #001F33;
		}

		.user-dropdown {
			background: #ffffff;
			border: 1px solid #E5E5EA;
			box-shadow: 1px 2px 5px 0 rgba(0, 0, 0, 0.1);

			.splitter {
				background: #E5E5EA;
			}

			.name-container {
				.initials {
					background: #00FFFF;
				}

				.names {
					.name {
						color: #001F33;
					}

					.email {
						color: #001F33;
					}
				}
			}

			.logout-button {
				color: #001F33;
			}
		}
	}
}
</style>
